import hostClient from "../../../../yoello-lib/modules/host/HostClient";
import { INewVenueState, NewVenueStages } from "../types";
import { SET_HUBSPOT_ID, SET_LEAD_ID, SET_STAGE, SET_SUBSCRIPTION, SET_VENUE_DATA } from "./newVenue.action";


const host = hostClient.host;

export const initalState = {
    stage: NewVenueStages.VenueDetails,
    host,
    VenueDetails: { venue_location: host !== "partners" ? { name: "United Kingdom", value: "GB" } : undefined }
}

export function newVenueReducer(state: INewVenueState, action: any) {
    switch (action.type) {
        case SET_STAGE:
            return {
                ...state,
                stage: action.payload
            }
        case SET_VENUE_DATA:
            let stage = NewVenueStages.VenueSubscription;
            let subscription = undefined;
            if (action.payload.onboarding_source !== "YOELLO") {
                subscription = "1";
                stage = NewVenueStages.Completed;
            }
            return {
                ...state,
                VenueDetails: action.payload.venueDetails,
                stage,
                selectedSubscription: subscription
            }
        case SET_SUBSCRIPTION:
            return {
                ...state,
                selectedSubscription: action.payload
            }
        case SET_LEAD_ID:
            return {
                ...state,
                leadId: action.payload
            }
        case SET_HUBSPOT_ID:
            return {
                ...state,
                hubspotId: action.payload
            }
    }
    return state;
}